
<div class="background-overlay">
  <div class="content-modal">
    <div class="modal-content">
      <ng-container>
<div class="description-outer">
<div (click)="backToHome()" class="description-container close-position">
  <span class="close-text" [theme]="themeOptions">{{'close' | translate }}</span>
  <img
  src="/assets/images/wj_Icon_24_Close.svg"
  data-qa="close-button"
  class="close"
  aria-label="close"
/>
</div>
</div>
<div class="access" [theme]="themeOptions"> 
  <ng-container *ngIf="!_data.pickupOrder">{{'guest-description' | translate}}. </ng-container>
  <ng-container *ngIf="_data.pickupOrder">{{'pickup-guest-description' | translate}}. </ng-container>
  <p>{{'max-guest-statement' | translate }}: {{_data.maxGuests}} </p>
  <ng-container *ngIf="_data.guestsInActiveOrders > 0">({{_data.guestsInActiveOrders}} {{'inprogress-table-status' | translate }})</ng-container>
</div>
<div class="guest-number">
  <input  
  tabindex="1" 
  #customerCount 
  type="number" 
  maxlength="2" 
  [ngClass]="{errorBox:(isHavingValue || personCount>_data.maxGuests),normalInput:(personCount && personCount>0 && personCount <= _data.maxGuests)}" 
  name="customerCount" 
  [(ngModel)]="personCount" 
  (keyup)="checkFormat($event)" 
  id="customerCount" 
  class="form__field" 
  placeholder="Number of guests">
  
  <label for="customerCount" [theme]="themeOptions" [ngClass]="{errorLabel:(isHavingValue || personCount <1),normalLabel:(personCount && personCount>=0)}" class="form__label">{{'number-guests' | translate}}</label>
  <span class="clear-text"*ngIf="!isHavingValue&&personCount>0" (click)="clearvalue()" [theme]="themeOptions">{{'clear' | translate}}</span>
  <div
  class="text-danger"
  *ngIf="(isHavingValue|| personCount>_data.maxGuests)"
>
  <ng-continer *ngIf="isHavingValue">{{ 'valid-number' | translate }}</ng-continer>
  <ng-continer *ngIf="(personCount>_data.maxGuests)"> {{'max-guest-statement' | translate }}: <strong>{{_data.maxGuests}}</strong></ng-continer>
</div>
</div>

<div class="customer-name">
  <input  
  tabindex="2" 
  type="string" 
  maxlength="255" 
  name="customerName" 
  [(ngModel)]="guest.name" 
  id="customerName" 
  class="form__field" 
  />
  
  <label for="customerName" [theme]="themeOptions" [ngClass]="{normalLabel:(guest?.name?.length > 0)}" class="form__label">{{'name-optional' | translate}}</label>
  <span class="clear-text"*ngIf="guest?.name?.length > 0" (click)="clearNameValue()" [theme]="themeOptions">{{'clear' | translate}}</span>
</div>

<div class="btn-container">
  <button type="button" [theme]="themeOptions" (click)="personCountSubmit(customerCount.value)"  class="btn-primary">{{ 'continue' | translate}}</button>
</div>
      </ng-container>
      <ng-template #futureLoader>
        <div class="loader-date loader"></div>
        <div class="loader-time loader"></div>
      </ng-template>
    </div>
  </div>
</div>

